<div class="doughnut-title">
  <div class="bottom-title">{{ questionCategoriesRate.name }}</div>
</div>
<canvas [attr.id]="canvasId" height="200"></canvas>
<img hidden [attr.id]="canvasImgId" height="78"/>
